import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWindowDimensions } from "resources/BrowserManager";
import ApiManager from "resources/ApiManager/api";

import {
  Layout,
  Button,
  Dropdown,
  Flex,
  theme,
  Drawer,
  Alert,
  Typography,
} from "antd";
const { Text } = Typography;
const { Header } = Layout;

import { useStore } from "store";

import {
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuOutlined,
  CloseOutlined,
  ToolOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
} from "@ant-design/icons";

import "./style.scss";
const styleWrapperClass = "topbar";

import { RfcCardHorizontal } from "components/Shared/RfcCard";
import { SubscriptionCard } from "routes/Cuenta/components";
import SideBar from "../SideBar";
import ModalFeedbackBubble from "./ModalFeedbackBubble";

const CustomDrawer = ({ showButton, siderWidth }) => {
  const { token: theme_token } = theme.useToken();

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  return (
    <Flex style={{ marginTop: "3px" }}>
      {showButton && (
        <MenuOutlined
          className="btn-menu"
          style={{ color: theme_token.colorSecondary }}
          onClick={() => setDrawerOpen(true)}
        />
      )}
      <Drawer
        placement="left"
        closable={false}
        onClose={() => setDrawerOpen(false)}
        open={isDrawerOpen}
        key="left"
        width={siderWidth}
        style={{
          background: "linear-gradient(135deg, #FFE8FC, 20%, #E2F7FF)",
        }}
      >
        <Flex justify="flex-end">
          <CloseOutlined
            style={{
              color: theme_token.colorSecondary,
              fontSize: "18px",
              marginTop: "10px",
            }}
            onClick={() => setDrawerOpen(false)}
          />
        </Flex>
        <SideBar isDrawer={true} setDrawerOpen={setDrawerOpen} />
      </Drawer>
    </Flex>
  );
};

const AlertSubscriptionPastDue = () => {
  const { isSmallView } = useWindowDimensions();
  const user = useStore((state) => state.user);

  return (
    user.stripe.open_invoices?.length > 0 && (
      <Alert
        message={
          <Flex
            justify="space-between"
            align={isSmallView ? "flext-start" : "center"}
            vertical={isSmallView}
            gap={isSmallView ? 10 : 0}
            style={{ marginLeft: isSmallView ? "15px" : null }}
          >
            <Text>
              <span style={{ fontWeight: "bold" }}>
                ¡Tu cuenta tiene adeudos!
              </span>
              <br />
              Realiza el pago del importe adeudado lo antes posible para evitar
              interrupciones en tu subscripción.
            </Text>
            <Button
              type="primary"
              icon={<ExportOutlined />}
              onClick={() =>
                window.open(
                  user.stripe.open_invoices[0].hosted_invoice_url,
                  "_blank",
                )
              }
            >
              Ver Adeudo
            </Button>
          </Flex>
        }
        type="error"
        icon={<ExclamationCircleOutlined style={{ fontSize: "20px" }} />}
        showIcon
        style={{ padding: "20px" }}
      />
    )
  );
};

export default function TopBar({ hideSider, siderWidth }) {
  const { token: theme_token } = theme.useToken();

  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const user = useStore((state) => state.user);
  const clearStore = useStore((state) => state.clearStore);
  const setActiveRfc = useStore((state) => state.setActiveRfc);
  const setStartLogout = useStore((state) => state.setStartLogout);
  const setEndLogout = useStore((state) => state.setEndLogout);

  const handleAccountSelectChange = async (value) => {
    if (value.key === "logout") {
      setStartLogout();
      await ApiManager.postUserLogout();
      setEndLogout();
      clearStore(); //Will automatically redirect to login
    } else if (value.key === "account") {
      navigate("/cuenta");
    } else if (value.key === "admin") {
      setActiveRfc("admin-empty");
      navigate("/admin/rfcs");
    }
  };

  const menuProps = {
    items: [
      {
        style: {
          width: "200px",
        },
        key: "account",
        value: "account",
        label: (
          <Flex justify="flex-start" gap={10}>
            <UserOutlined />
            Cuenta
          </Flex>
        ),
      },
      user.user_level === "admin" && {
        key: "admin",
        value: "admin",
        label: (
          <Flex justify="flex-start" gap={10}>
            <ToolOutlined />
            Admin
          </Flex>
        ),
      },
      { type: "divider" },
      {
        key: "logout",
        label: (
          <Flex justify="flex-start" gap={10}>
            <LogoutOutlined />
            <span>Cerrar Sesión</span>
          </Flex>
        ),
      },
      {
        label: user.email,
        disabled: true,
        style: { color: "rgb(90, 90, 90)", cursor: "default" },
      },
    ],
    onClick: handleAccountSelectChange,
  };

  const SettingsDropDown = () => (
    <Dropdown menu={menuProps} trigger="click" placement="bottomRight">
      <SettingOutlined
        className="btn-settings"
        style={{
          color: theme_token.colorSecondary,
          marginLeft: "5px",
        }}
      />
    </Dropdown>
  );

  const layout =
    width >= 1100 ? (
      <Flex vertical gap={20}>
        <Flex
          justify="space-between"
          align="flex-start"
          style={{ marginTop: "15px" }}
        >
          <Flex justify="flex-start" align="flex-start" gap={15}>
            <CustomDrawer showButton={hideSider} siderWidth={siderWidth} />
            <RfcCardHorizontal />
          </Flex>

          <Flex align="start">
            <ModalFeedbackBubble />
            <SettingsDropDown />
          </Flex>
        </Flex>
        <AlertSubscriptionPastDue />
      </Flex>
    ) : (
      <Flex vertical gap={20}>
        <Flex vertical>
          <Flex justify="space-between" style={{ marginTop: "15px" }}>
            <CustomDrawer showButton={hideSider} siderWidth={siderWidth} />

            <Flex justify="flex-end" style={{ zIndex: 10 }}>
              <ModalFeedbackBubble />
              <SettingsDropDown />
            </Flex>
          </Flex>

          <div style={{ marginLeft: "30px", marginTop: "-21px" }}>
            <RfcCardHorizontal />
          </div>
        </Flex>
        <AlertSubscriptionPastDue />
      </Flex>
    );

  return <Header className={styleWrapperClass}>{layout}</Header>;
}
